module.exports = __webpack_public_path__ + "static/media/compass.0bfbe0a5.png";